import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  html{
    scroll-behavior: smooth;
  }
  * {
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
    font-family: 'Noto Sans Mono', sans-serif;
  }

  body {
    background-color: #F4F4F4;
    margin: 0;
    letter-spacing: 0.07em;
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 5px;
  }

  ::-webkit-scrollbar-corner {
    height: 0;
  }

  ::-webkit-scrollbar-track {
    background-color: #C1A99C;
    border-radius: 25px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #e9d1bc;
    border-radius: 25px;
  }
  .leaflet-container {
    height: 500px;
    width: 900px;
  }
  a{
    text-decoration: underline;
    cursor: pointer;
    color: black;
  }
`;

export default GlobalStyles;